import { Route, useLocation } from 'preact-iso';
import { exec } from 'preact-iso/router';
import Router from 'applications/common/routing/router.js';
import MojitoModules from 'mojito/modules';
import MojitoPresentation from 'mojito/presentation';
import HomePage from 'applications/sports/pages/home-page/index.js';
import InPlayPage from 'applications/sports/pages/inplay-page/index.js';
import SportPage from 'applications/sports/pages/sport-page/index.js';
import CompetitionsView from 'applications/sports/pages/sport-page/views/competitions-view/index.js';
import MatchesView from 'applications/sports/pages/sport-page/views/matches-view/index.js';
import PriceBoostsView from 'applications/sports/pages/sport-page/views/price-boosts-view/index.js';
import PrebuiltBetsView from 'applications/sports/pages/sport-page/views/pre-built-bets-view/index.js';
import OutrightsView from 'applications/sports/pages/sport-page/views/outrights-view/index.js';
import HighlightsView from 'applications/sports/pages/sport-page/views/highlights-view/index.js';
import MeetingsView from 'applications/sports/pages/sport-page/views/meetings-view/index.js';
import SingleLeaguePage from 'applications/sports/pages/single-league-page/index.js';
import PriceBoostsLeague from 'applications/sports/pages/price-boosts-league/index.js';
import PrebuiltBetBuilderLeague from 'applications/sports/pages/pre-built-bet-builder-league/index.js';
import SportDefaultPage from 'applications/sports/pages/sport-default-page/index.js';
import SportCouponPage from 'applications/sports/pages/sport-coupon-page/index.js';
import RaceMeetingPage from 'applications/sports/pages/race-meeting-page/index.js';
import FutureRacePage from 'applications/sports/pages/future-race-page/index.js';
import MyAccountPage from 'applications/sports/pages/my-account-page/index.js';
import BadRoutePage from 'applications/sports/pages/bad-route-page/index.js';
import VirtualSportPage from 'applications/sports/pages/virtual-sport-page/index.js';
import PriceBoostPage from 'applications/sports/pages/price-boost-page/index.js';
import DeepLinkingController from 'applications/sports/app/routing/deep-linking/deep-linking-controller.js';
import InplayEventController from 'applications/sports/app/routing/inplay-event/index.js';
import Protected from 'applications/common/routing/protected/index.js';

const {
    types: { NAVIGATION },
    NavigationPathBuilder,
} = MojitoPresentation.Base.Navigation;
const CustomRedirect = MojitoModules.CustomRedirect;
const { SingleLeagueCoupon, SingleLeagueCouponTypes } = MojitoModules.SingleLeagueCoupon;
const { COUPONS } = SingleLeagueCouponTypes;
const { useLocalizedParams } = MojitoPresentation.Hooks;

export default function RoutingView(props) {
    const { appContext, config } = props.mojitoTools;
    const { routeResolver } = appContext;
    const { customRoutes } = config;
    const sportNavigation = routeResolver.getPattern(NAVIGATION.SPORT_PAGE);
    const leagueNavigation = routeResolver.getPattern(NAVIGATION.COMPETITIONS_LEAGUE);
    const homeNavigation = routeResolver.getPattern(NAVIGATION.HOME);
    const quickStartGuidePath = routeResolver.enrichWithRoot(
        homeNavigation.nested[NAVIGATION.QUICK_START_GUIDE]
    );
    const { path: pathname } = useLocation();
    const isQuickStartPath = !!exec(pathname, quickStartGuidePath);

    return (
        <Router>
            {renderCustomRoutes(customRoutes)}
            <Route
                path={routeResolver.getPattern(NAVIGATION.REDIRECT_HOME_1)}
                component={RedirectToHome}
            />
            <Route
                path={routeResolver.getPattern(NAVIGATION.REDIRECT_HOME_2)}
                component={RedirectToHome}
            />
            <Route
                path={[
                    routeResolver.getPattern(NAVIGATION.INPLAY_PAGE),
                    routeResolver.getPattern(NAVIGATION.INPLAY_SPORT_PAGE),
                ]}
                component={InPlayPage}
            />
            <Route
                path={routeResolver.getPattern(NAVIGATION.SPORT_EVENT_PAGE)}
                component={InplayEventController}
            />
            <Route
                path={routeResolver.getPattern(NAVIGATION.RACE_PAGE)}
                component={RaceMeetingPage}
            />
            <Route
                path={routeResolver.getPattern(NAVIGATION.FUTURE_RACE_PAGE)}
                component={FutureRacePage}
            />
            <Route
                path={leagueNavigation.path}
                component={CompetitionsLeaguePageRoute}
                leagueNavigation={leagueNavigation}
            />
            <Route
                path={routeResolver.getPattern(NAVIGATION.OUTRIGHTS_LEAGUE)}
                component={OutrightsLeaguePageRoute}
            />
            <Route
                path={routeResolver.getPattern(NAVIGATION.SPORTS_COUPON_PAGE)}
                component={SportCouponPage}
            />
            <Route
                path={sportNavigation.path}
                component={SportPageRoute}
                sportNavigation={sportNavigation}
            />
            <Route
                path={routeResolver.getPattern(NAVIGATION.INPLAY_EVENT_PAGE)}
                component={InplayEventController}
                isInplayRoute
            />
            <Route
                path={routeResolver.getPattern(NAVIGATION.RACE_MEETING_PAGE)}
                component={RaceMeetingPage}
            />
            <Route
                path={[
                    routeResolver.getPattern(NAVIGATION.VIRTUAL_SPORT_PAGE),
                    routeResolver.getPattern(NAVIGATION.VIRTUAL_EVENT_PAGE),
                ]}
                component={VirtualSportPage}
            />
            <Route
                path={routeResolver.getPattern(NAVIGATION.PRICE_BOOST_PAGE)}
                component={PriceBoostPage}
            />
            <Route
                path={routeResolver.getPattern(NAVIGATION.DEEP_LINKS_ADD_SELECTIONS)}
                component={DeepLinkingController}
            />
            <Route
                path={routeResolver.getPattern(NAVIGATION.ACCOUNT_PAGE)}
                component={ProtectedMyAccountPage}
            />
            <Route
                path={[homeNavigation.path, quickStartGuidePath]}
                component={HomePage}
                showQuickStartGuide={isQuickStartPath}
            />
            <Route default component={BadRoutePage} />
        </Router>
    );
}

const SportPageRoute = props => {
    const { sportNavigation } = props;
    return (
        <SportPage>
            <Router>
                <Route
                    path={sportNavigation.nested[NAVIGATION.COMPETITIONS]}
                    component={CompetitionsView}
                />
                <Route path={sportNavigation.nested[NAVIGATION.MATCHES]} component={MatchesView} />
                <Route
                    path={sportNavigation.nested[NAVIGATION.PRICE_BOOSTS]}
                    component={PriceBoostsView}
                />
                <Route
                    path={sportNavigation.nested[NAVIGATION.PRE_BET_BUILDERS]}
                    component={PrebuiltBetsView}
                />
                <Route
                    path={sportNavigation.nested[NAVIGATION.OUTRIGHTS]}
                    component={OutrightsView}
                />
                <Route
                    path={sportNavigation.nested[NAVIGATION.HIGHLIGHTS]}
                    component={HighlightsView}
                />
                <Route path={sportNavigation.nested[NAVIGATION.FUTURE]} component={OutrightsView} />
                <Route
                    path={sportNavigation.nested[NAVIGATION.MEETINGS]}
                    component={MeetingsView}
                />
                <Route default component={SportDefaultPage} />
            </Router>
        </SportPage>
    );
};

const RedirectToHome = () => {
    return <CustomRedirect toNav={NavigationPathBuilder.toHome()} />;
};

const OutrightsLeaguePageRoute = () => (
    <SingleLeaguePage pageType={COUPONS.OUTRIGHTS}>
        <SingleLeagueCoupon />
    </SingleLeaguePage>
);

const CompetitionsLeaguePageRoute = props => {
    const { leagueNavigation } = props;
    return (
        <SingleLeaguePage pageType={COUPONS.COMPETITIONS}>
            <Router>
                <Route
                    path={leagueNavigation.nested[NAVIGATION.MATCHES_LEAGUE]}
                    component={SingleLeagueCoupon}
                />
                <Route
                    path={leagueNavigation.nested[NAVIGATION.PRICE_BOOSTS_LEAGUE]}
                    component={PriceBoostsLeague}
                />
                <Route
                    path={leagueNavigation.nested[NAVIGATION.BET_BUILDERS_LEAGUE]}
                    component={PrebuiltBetBuilderLeague}
                />
                <Route default component={LeagueDefaultPage} />
            </Router>
        </SingleLeaguePage>
    );
};

function renderCustomRoutes(customRoutes = []) {
    return customRoutes.map(({ path, component }) => {
        return <Route path={path} component={component} key={path} />;
    });
}

const ProtectedMyAccountPage = () => (
    <Protected>
        <MyAccountPage />
    </Protected>
);

const LeagueDefaultPage = () => {
    const { sportId, typeId } = useLocalizedParams();
    return (
        <CustomRedirect
            toNav={NavigationPathBuilder.toSportMatchesLeague(sportId, typeId)}
            isReplace={true}
        />
    );
};
